import React from "react";
import { Slider } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

const VolumeSliderForm = ({ register, watch, setValue, preview = false, data = null }) => {
  // 1. Determine current value (default to 50 if undefined)
  const currentVolume = preview 
    ? (data?.volume ?? 50) 
    : (watch("formData.volume") ?? 50);

  // 2. Handle slider change
  const handleChange = (event, newValue) => {
    if (!preview) {
      setValue("formData.volume", newValue);
    }
  };

  return (
    <SoftBox 
      p={preview ? 1.5 : 2} 
      sx={{ 
        border: preview ? '1px solid #ddd' : '1px dashed #ccc', 
        borderRadius: '8px', 
        backgroundColor: '#fff',
        height: preview ? 'fit-content' : 'auto',
        overflowY: preview ? 'auto' : 'visible'
      }}
    >
      <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <SoftTypography 
          variant={preview ? "caption" : "body3"} 
          fontWeight="bold"
          textTransform="uppercase"
        >
          Volume
        </SoftTypography>
        
        <SoftTypography 
          variant="button" 
          fontWeight="medium" 
          color="info"
        >
          {currentVolume}%
        </SoftTypography>
      </SoftBox>

      <SoftBox px={1}>
        <Slider
          // Set range 1 to 100
          min={1}
          max={100}
          value={currentVolume}
          onChange={handleChange}
          disabled={preview}
          sx={{
            // Maintain the "Soft" theme look
            color: "info.main",
            height: 6,
            "& .MuiSlider-thumb": {
              width: 16,
              height: 16,
              backgroundColor: "#fff",
              border: "2px solid currentColor",
              "&:hover": {
                boxShadow: "0 0 0 8px rgba(25, 118, 210, 0.16)",
              },
            },
            "& .MuiSlider-track": {
              border: "none",
            },
            "& .MuiSlider-rail": {
              opacity: 0.5,
              backgroundColor: "#bfbfbf",
            },
          }}
        />
      </SoftBox>

      {/* Hidden input to register the field with react-hook-form */}
      {!preview && (
        <input 
          type="hidden" 
          {...register("formData.volume", { value: 50 })} 
        />
      )}
    </SoftBox>
  );
};

export default VolumeSliderForm;